<template>
  <Modal
    :model-value="modelValue"
    :title="MODAL_TITLE"
    :show-title="true"
    :show-title-icon="true"
    title-icon-type="direct"
    :show-close="true"
    :close-on-backdrop="true"
    :close-on-esc="true"
    :auto-focus="false"
    :max-width="560"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <div class="platform-direct-modal text-start color-black-02">
      <div class="px-2">
        <p>
          「社内SE転職ナビ
          企業スカウト」をご利用いただくと、求人を掲載する企業と直接メッセージのやり取り、求人応募が可能です。
        </p>
        <p>
          エージェントサービスと並行してサービスをご利用することができますので、ぜひご利用ください。
        </p>
        <p>ぜひこの機会にご自身のプロフィール情報を充実させてください。</p>
        <p>プロフィール情報をもとに、企業からのスカウトが届くかもしれません。</p>
        <p>
          ご利用される場合は
          <a
            class="platform-direct-modal__terms-link d-inline-flex align-items-center gap-1"
            href="/terms"
            target="_blank"
            rel="noopener noreferrer"
          >
            利用規約
            <svg
              width="13"
              height="14"
              viewBox="0 0 13 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M8.125 0.5C7.67559 0.5 7.3125 0.863086 7.3125 1.3125C7.3125 1.76191 7.67559 2.125 8.125 2.125H10.2248L5.11367 7.23867C4.79629 7.55605 4.79629 8.07148 5.11367 8.38887C5.43105 8.70625 5.94648 8.70625 6.26387 8.38887L11.375 3.2752V5.375C11.375 5.82441 11.7381 6.1875 12.1875 6.1875C12.6369 6.1875 13 5.82441 13 5.375V1.3125C13 0.863086 12.6369 0.5 12.1875 0.5H8.125ZM2.03125 1.3125C0.908984 1.3125 0 2.22148 0 3.34375V11.4688C0 12.591 0.908984 13.5 2.03125 13.5H10.1562C11.2785 13.5 12.1875 12.591 12.1875 11.4688V8.625C12.1875 8.17559 11.8244 7.8125 11.375 7.8125C10.9256 7.8125 10.5625 8.17559 10.5625 8.625V11.4688C10.5625 11.6922 10.3797 11.875 10.1562 11.875H2.03125C1.80781 11.875 1.625 11.6922 1.625 11.4688V3.34375C1.625 3.12031 1.80781 2.9375 2.03125 2.9375H4.875C5.32441 2.9375 5.6875 2.57441 5.6875 2.125C5.6875 1.67559 5.32441 1.3125 4.875 1.3125H2.03125Z"
                fill="currentColor"
              />
            </svg>
          </a>
          をご確認・ご同意の上、利用開始してください。
        </p>
      </div>

      <p v-if="errorMessage" class="text-danger text-center mb-2 px-2" role="alert">
        {{ errorMessage }}
      </p>
      <div class="d-flex justify-content-center pt-3 pb-4">
        <Button type="button" :disabled="loading" @click="activateAndGoToDirectJobs()">
          規約に同意して企業スカウトサービスを利用する
        </Button>
      </div>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import Button from '@/components/shared/button/Button.vue';
import Modal from '@/components/shared/modal/Modal.vue';
import { useWelcomeGuideDirectActivation } from '@/composables/useWelcomeGuideDirectActivation';

const MODAL_TITLE = '求人掲載企業と直接やり取りをしてみませんか？';

defineProps<{
  modelValue: boolean;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
}>();

const { loading, errorMessage, activateAndGoToDirectJobs } = useWelcomeGuideDirectActivation();
</script>

<style scoped lang="scss">
@import '@/assets/stylesheets/components/_variables.scss';

.platform-direct-modal .platform-direct-modal__terms-link {
  color: $primary-blue;
}
</style>
